<template>
    <div id="panel-info" class="panel">
        <div   class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Інформація
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show overflow-auto">
            
            <div class="panel-content">
                
                <div id="date_from"><div class="control-group">
                    <div class="control-label"><label id="jform_date_from-lbl"  class="inputname">
                        Початок тендера</label>
                    </div>
                    <div class="controls"><div class="simple_text">
                        {{reduction.date_from}}</div></div>
                </div>
                </div>
                <div id="date_to">
                    <div class="control-group">
                        <div class="control-label"><label id="jform_date_to-lbl"  class="inputname">
                            Закінчення тендера</label>
                        </div>
                        <div class="controls"><div class="simple_text">
                            {{ reduction.date_to }}</div>
                        </div>
                    </div>
                </div>
                <div class="control-group">
                    <div class="control-label"><label id="jform_cat_group_name-lbl"  class="inputname">
                        Группа категорії закупки</label>
                    </div>
                    <div class="controls"><div class="simple_text">{{reduction.cat_group_name}}</div></div>
                </div>
                <div class="control-group">
                    <div class="control-label"><label id="jform_category_name-lbl"  class="clcategorys">
                        Категорія закупки</label>
                    </div>
                    <div class="controls"><div class="simple_text">{{reduction.category_name}}</div></div>
                </div>
                <div id="currency_name">
                    <div class="control-group">
                        <div class="control-label"><label id="jform_date_to-lbl"  class="inputname">
                            Валюта торгів</label>
                        </div>
                        <div class="controls"><div class="simple_text">
                            {{ reduction.currency_name }}</div>
                        </div>
                    </div>
                </div>
            
            </div>
        </div>
    </div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'reduction/getReductionField',
    mutationType: 'reduction/updateReductionField',
});


export default {
    name: "reduction_info",
    computed: {
        ...mapFields([
            'reduction',
        ]),
    }
}
</script>



<style scoped>

</style>